import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersKey,
  getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200,
  GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200>(
    getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetInternalNewsList = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200>
  >;
};

/**
 * 社内報一覧取得フック
 */
export const useGetInternalNewsList: IUseGetInternalNewsList = ({ threeLetterCode, page }) => {
  const apiParams: GetApiV1ThreeLetterCodeClientAdminsClientNewslettersParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsClientNewsletters200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsClientNewslettersKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
